import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { class: "rounded-lg border border-slate-200 bg-white p-3 shadow-[0_12px_30px_rgba(15,23,42,0.06)]" }
const _hoisted_3 = { class: "flex flex-wrap items-start justify-between gap-4" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-4 xl:grid-cols-[280px_minmax(0,1fr)]" }
const _hoisted_5 = { class: "sticky top-20 h-fit rounded-lg border border-slate-200 bg-white p-3 shadow-[0_10px_24px_rgba(15,23,42,0.05)] max-xl:static" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "truncate" }
const _hoisted_8 = { class: "flex min-w-0 flex-col gap-4" }
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "border-b border-slate-200 bg-slate-50 px-4 py-4" }
const _hoisted_11 = { class: "flex flex-wrap items-start justify-between gap-3" }
const _hoisted_12 = { class: "flex items-center gap-2" }
const _hoisted_13 = { class: "inline-flex h-9 w-9 items-center justify-center rounded-lg bg-teal-100 text-teal-800" }
const _hoisted_14 = { class: "text-[18px] font-black mb-0 text-slate-950" }
const _hoisted_15 = { class: "mt-2 text-sm font-medium leading-6 text-slate-600" }
const _hoisted_16 = { class: "grid grid-cols-1 gap-4 p-4 lg:grid-cols-[minmax(0,1fr)_360px]" }
const _hoisted_17 = { class: "overflow-hidden rounded-lg border border-slate-200 bg-slate-50" }
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = { class: "flex flex-col gap-4" }
const _hoisted_20 = { class: "mt-2 flex list-decimal flex-col gap-2 pl-5 text-sm font-medium leading-6 text-slate-700" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "mt-2 flex list-disc flex-col gap-2 pl-5 text-sm font-medium leading-6 text-slate-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", null, [
          _createElementVNode("p", { class: "text-[24px] font-black leading-8 text-slate-950" }, " Hướng dẫn sử dụng hệ thống "),
          _createElementVNode("p", { class: "mt-2 max-w-4xl text-[15px] font-medium leading-6 text-slate-600" }, " Tài liệu thao tác nhanh theo từng chức năng trong menu, kèm ảnh minh họa trực quan. ")
        ], -1)),
        _createVNode(_component_RouterLink, {
          to: "/faq",
          class: "inline-flex min-h-10 items-center gap-2 rounded-lg border border-teal-200 bg-teal-50 px-4 py-2 text-sm font-extrabold !text-teal-800 !no-underline transition hover:bg-teal-100"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "pi pi-question-circle" }, null, -1),
            _createTextVNode("Xem FAQ", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("aside", _hoisted_5, [
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "px-2 pb-2 text-xs font-black uppercase text-slate-500" }, " Mục hướng dẫn ", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.guideItems, (item) => {
          return (_openBlock(), _createElementBlock("a", {
            key: item.id,
            href: `#${item.id}`,
            class: "flex min-h-10 items-center gap-2 rounded-md px-2 py-2 text-sm font-bold !text-slate-700 !no-underline transition hover:bg-teal-50 hover:!text-teal-800"
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["pi text-[13px] text-teal-700", item.icon])
            }, null, 2),
            _createElementVNode("span", _hoisted_7, _toDisplayString(item.title), 1)
          ], 8, _hoisted_6))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.guideItems, (item) => {
          return (_openBlock(), _createElementBlock("article", {
            id: item.id,
            key: item.id,
            class: "scroll-mt-24 overflow-hidden rounded-lg border border-slate-200 bg-white shadow-[0_12px_30px_rgba(15,23,42,0.06)]"
          }, [
            _createElementVNode("header", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["pi", item.icon])
                      }, null, 2)
                    ]),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(item.title), 1)
                  ]),
                  _createElementVNode("p", _hoisted_15, _toDisplayString(item.description), 1)
                ]),
                _createVNode(_component_RouterLink, {
                  to: item.route,
                  class: "inline-flex min-h-9 items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-extrabold !text-slate-700 !no-underline transition hover:border-teal-200 hover:bg-teal-50 hover:!text-teal-800"
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("i", { class: "pi pi-external-link" }, null, -1),
                    _createTextVNode("Mở chức năng", -1)
                  ]))]),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("img", {
                  src: item.screenshot,
                  alt: `Ảnh minh họa ${item.title}`,
                  class: "block w-full bg-white object-contain",
                  loading: "lazy"
                }, null, 8, _hoisted_18)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-[14px] font-black uppercase text-slate-500" }, " Cách thao tác ", -1)),
                  _createElementVNode("ol", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.steps, (step) => {
                      return (_openBlock(), _createElementBlock("li", { key: step }, _toDisplayString(step), 1))
                    }), 128))
                  ])
                ]),
                (item.notes.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-[14px] font-black uppercase text-slate-500" }, " Lưu ý ", -1)),
                      _createElementVNode("ul", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.notes, (note) => {
                          return (_openBlock(), _createElementBlock("li", { key: note }, _toDisplayString(note), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 8, _hoisted_9))
        }), 128))
      ])
    ])
  ]))
}